export default "__VITE_PUBLIC_ASSET__8de5c733__"